import { render, staticRenderFns } from "./CApp.vue?vue&type=template&id=c3125668"
import script from "./CApp.vue?vue&type=script&lang=js"
export * from "./CApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports